import { render, staticRenderFns } from "./InquiryAllCategoryPop.vue?vue&type=template&id=0277e33a&scoped=true&"
import script from "./InquiryAllCategoryPop.vue?vue&type=script&lang=js&"
export * from "./InquiryAllCategoryPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0277e33a",
  null
  
)

component.options.__file = "InquiryAllCategoryPop.vue"
export default component.exports